import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

const VisualMode = (props) => {
  const { title, rateCode } = props;

  return (
    <Row className="contract-component__container auto-margin">
      <Col sm="12" className="component-title">
        {title}
      </Col>
      <Col sm="12" className="component-form">
        <label className="read-only-label">
          {rateCode}
        </label>
      </Col>
    </Row>
  );
};

VisualMode.propTypes = {
  title: PropTypes.string,
  rateCode: PropTypes.string
};

VisualMode.defaultProps = {
  title: '',
  rateCode: ''
};

export default VisualMode;
